import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import store from "../../../../../store";
import {Layout} from "../../layout";
import {createParentPositions, METADATA, SIDE_POSITIONS, VANITY_TYPES, LOOK_ROOM_TYPES} from "../../constants";
import {updateSinkWithNewFeature} from "../../../lookNavigation/lookNavigationFunctions";
import {getCurrentRoomType} from "../../../../appLayout";

export default class VanityCabinet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_cabinet';
    this.partName = 'Vanity Cabinet';
    this.translateId = "visualizer.bathroom.vanity.vanity_cabinet";
    this.dbName = "Vanitie";
    this.homePageTitle = 'Vanity Bases';
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    this.canUseWizard = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  load(dbFeature) {
    if (dbFeature.groupName === "Vanitie") {
      dbFeature.groupName = "Vanity"
    }
    if (!dbFeature.metaData["MatchingFeature"]) {
      dbFeature.metaData["MatchingFeature"] = [METADATA.NO];
    }
    if (!dbFeature.metaData["Side"]) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    if (Array.isArray(dbFeature.metaData["VanitySize"]) && dbFeature.metaData["VanitySize"][0]) {
      dbFeature.metaData["VanityWidth"] = +dbFeature.metaData["VanitySize"][0];
      if (dbFeature.metaData["VanityWidth"] === 72) {
        dbFeature.metaData["VanityWidth"] = 64;
      }
    } else if (dbFeature.metaData["VanitySize"]) {
      console.log("dbFeature.metaData[\"VanitySize\"] should be an array!", dbFeature.metaData["VanitySize"]);
    }
    return super.load(dbFeature);
  }

  disabledClick() {
    const vanityParent = this.getParent();
    if (getCurrentRoomType(vanityParent.layout) === LOOK_ROOM_TYPES.as) {
      this.toggleLayerPositions();
      ["drawerPull", "vanityLegs", "vanityMiddle"].forEach(name => {
        if (vanityParent && vanityParent[name]) {
          vanityParent[name].disabled = this.disabled || !vanityParent[name].canBeEnabled(); // true or check if it can be enabled;
        }
      });
      if (this.activeFeature && this.activeFeature.metaData["MatchingFeature"] && this.activeFeature.metaData["MatchingFeature"].includes(METADATA.NO)) {
        ["sink", "countertop", "vanityPTrap", "faucet"].forEach(name => {
          if (vanityParent && vanityParent[name]) {
            vanityParent[name].disabled = this.disabled || !vanityParent[name].canBeEnabled(); // true or check if it can be enabled;
          }
        });
      }
    }
  }

  handleClick(ignoreLocked, updateSink = true) {
    const vanityParent = this.getParent().getParent();
    vanityParent.vanity_type = VANITY_TYPES.vanity_cabinet;
    super.handleClick(ignoreLocked);
    if (updateSink) {
      updateSinkWithNewFeature(this);
    }
    vanityParent.updateVanityParts();
  }

  // navigationSubItems() {
  //   return super.navigationSubItemsWithFilter('VanitySize', this.getParent().counterTopSize(this));
  // }

  // disabledClick() {
  //   this.getParent().toggleVanityParts(this.disabled);
  // }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return (getCurrentRoomType(vanityParent.layout) === LOOK_ROOM_TYPES.as) && (vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet)
  }

  setActiveFeatureByFilter(filterName, filterValue) {

    // console.log('filterName', filterName);
    // console.log('filterValue', filterValue);

    const filterGroups = store.getState().filterState.filterGroups;
    const group = filterGroups.find(group => group.name === filterName);
    const groupId = group.id;
    const filterValueId = Layout.getfilterValueIdByValue(groupId, filterValue);
    const filteredFeatures = this.features.filter(
      feature => feature.dbFeature && feature.dbFeature.filterValueIDs[groupId] && feature.dbFeature.filterValueIDs[groupId].includes(filterValueId)
    );    // find among all features only those, who have filter with value === props size
    if (!super.tryToSetTheSameFeature(filteredFeatures, null, "ustom")) {
      this.activeFeature = filteredFeatures[0];
      const placeholderAvailableFeatures = filteredFeatures.filter(feature => {
        return feature.dbFeature.displayName.includes("laceholder") && feature.dbFeature.displayName.includes("ustom")
      });
      this.placeholderFeature = placeholderAvailableFeatures[0];
    }
  }

  // getAvailableFeatures() {
  //   return this.features.filter(f => f.vanitySize+'in' === this.getParent().counterTopSize(this));
  // }

  canDisplayDemoPoint(parentObject) {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as && parentObject.layerPosition === SIDE_POSITIONS[0]) {
      return false
    }
    return this.getParent().vanity_type === VANITY_TYPES.vanity_cabinet
  }
}
